import React from 'react';
import Main from '../../components/Main';
import {Row, Col, Container } from 'react-bootstrap';
import LongCard from '../../components/LongCard';
import '../../assets/styles/Global.css';

// Services Subpage of AboutUs Page

const images = {};

function importAll(r) {
  r.keys().forEach((key) => {
    images[key.replace('./', '')] = r(key);
  });
}


// Imports all images from the services folder into the images array

importAll(require.context('../../assets/images/aboutus_icons/services', false, /\.(png|jpe?g|svg)$/));

const services = [
  {
    title: "Strategy Workshops",
    description: "Align your team around a shared vision in 2-4 weeks",
    details : `Having trouble aligning your team around a strategic vision
    and best practices action plan? This 2-week service mobilizes a leading
    expert in your field of operations, who runs a series of interviews with
    key stakeholders and organizes a plenary session to deliver a diagnostic,
    explore viable options and build alignment on next steps.`,
    icon: images['services_1.png'],
  },
  {
    title: "Digital Solutions",
    description: "World class digital services on time and on budget",
    details : `Most experts agree that digitalization drives sustainable competitive
    advantage. Whether you’re looking to build or buy, whether the solution is proprietary
    or based on open-source foundations, IQosys can help.Our engineering teams can provide
    the custom support and experience you need to successfully deliver world class apps on
    time and on budget.`,
    icon: images['services_2.png'],
  },
  {
    title: "Complex Projects",
    description: "Multi-role teams to deliver business solutions",
    details : `If you need to deploy a highly specialized team to deliver a complex
    project requiring analytics, process redesign,  ! Whatever the technology being
    deployed, the delivery timelines or project scope, we’ll mobilize the right team of
    consultants, whether PMO, technical, functional, or change management, to design a
    custom methodology and align with you on a detailed plan of action supported by KPIs.`,
    icon: images['services_3.png'],
  },
  {
    title: "Agile Innovation PMO",
    description: "Maximize your organization’s ability to stay ahead of the game",
    details : `Technology is advancing at a brisk pace. Staying ahead of your competition
    requires a lean innovation process and corporate culture.
    Delivering programs that exceed expectations requires a combination of experienced
    project managers supported by on-demand access to domain specific expertise. IQosys is the perfect fit to deliver this finely balanced cocktail.`,
    icon: images['services_4.png'],
  },
  {
    title: "Training & Education",
    description: "Build a highly competent, motivated team to achieve your objectives",
    details : `Building internal capabilities is the key to your company’s success.
    Whether to facilitate the deployment of an ERP, reinforce the technical expertise
    of your IT staff or ensure that your business teams are up to date on the latest regulatory requirements, we’re here to help.`,
    icon: images['services_5.png'],
  },
  {
    title: "Experts On Demand",
    description: "Agile teams deliver sprints faster and better",
    details : `In our fast-changing world, agile access to a wide pool of domain or sector expertise, whether for short term or longer-term engagements, represents a competitive advantage.
    4 days is the average time required between receiving a brief and mobilizing the right talent to help you accelerate your project delivery.`,
    icon: images['services_6.png'],
  },
];

const Services = () => {
  return (
    <div>
      <Main componentList={[
      <h6 className='top_sentence'>6 types of services engineered to deliver business results</h6>,
      <Col className="mt-4">
        {services.map((service, index) => (
          <Row md={6} lg={1} key={index}>
            <LongCard className="h-100 shadow-sm" longcard={service}/>
          </Row>
        ))}
      </Col>,
      <hr className="my-custom-hr"/>
      ]} />
    </div>
  );
};

export default Services;